
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import { IResetPassword } from '@/types/types';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';

extend('required', {
  ...required,
  message: 'Field is required',
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class ResetPassword extends mixins(WidgetMixins) {
  newPassword: string = '';
  confirmPassword: string = '';

  panelRows: IPanelRow[] = [
    {
      icon: 'password',
      title: 'Make it strong',
      text: 'Mix letters, numbers and symbols for a safer account.',
    },
    {
      icon: 'lock',
      title: 'Single-use link',
      text: 'This reset link expires as soon as you use it.',
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldState: any = {
    newPassword: false,
    confirmPassword: false,
  };

  resetPassword(): void {
    let payload: IResetPassword = {
      token: decodeURIComponent(this.$route.query.token as string),
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword,
    };

    this.$store.dispatch('auth/resetPassword', payload);
  }

  changeState(state: string): void {
    this.$set(this.fieldState, state, !this.fieldState[state]);
  }
}
